import React from 'react'

const Contact = ({ title, contactInfo, icon }) => {
  return (
    <div className='flex items-center gap-2'>
        <div className='w-10 h-10 [&>*]:size-6 bg-secondary rounded-full flex items-center justify-center text-primary'>{icon}</div>
        <div className='flex flex-col gap-1'>
            <h6 className='text-lg font-montserrat font-bold text-primary'>{title}</h6>
            <p className='text-sm font-montserrat text-gray-500'>{contactInfo}</p>
        </div>
    </div>
  )
}

export default Contact